import { OptionsFilter, ComboboxItem, ComboboxItemGroup } from "@mantine/core"

export const SelectStartsWithFilter: OptionsFilter = ({ options, search }) => {
  const lowerSearch = search.toLowerCase()
  return options.filter((item) => {
    if (isGroup(item)) {
      // Filter group if any of its items match
      return item.items.some((i) =>
        i.label.toLowerCase().startsWith(lowerSearch)
      )
    } else {
      // Filter single item
      return item.label.toLowerCase().startsWith(lowerSearch)
    }
  })
}

function isGroup(
  item: ComboboxItem | ComboboxItemGroup
): item is ComboboxItemGroup {
  return (
    typeof item === "object" && "items" in item && Array.isArray(item.items)
  )
}
